"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const SDK_1 = __importDefault(require("./SDK"));
module.exports = SDK_1.default;
//# sourceMappingURL=index.js.map